import AppModal, { registerModal } from './AppModal'
import AppModalLink from './AppModalLink'
import AppModalButton from './AppModalButton'

export { AppModal, AppModalLink, AppModalButton, registerModal }
export default AppModal
